import QRCode from 'react-qr-code';

const deepMapElements = (elements, deviceId, displayPosition, qrCodeIndex) => {
  if(elements.type === "view") {
    return <div style={elements.style}>
      {elements.elements.map(element => deepMapElements(element, deviceId, displayPosition, qrCodeIndex))}
    </div>
  }
  if(elements.type === "img") {
    return (
      <img 
        style={elements.style}
        src={elements.content}
      />
    )
  }
  if(elements.type === 'video') {
    if(elements.content.includes(".mp4") || elements.content.includes(".webm"))
      return <video style={elements.style} autoPlay muted loop>
         <source src={elements.content} type="video/webm" />
      </video>
  }
  if(elements.type === "text") {
    return <p dir='rtl' style={elements.style}>{elements.content}</p>
  }
  if(elements.type ==="qrcode_dyn") {
    return <div style={{backgroundColor:"white"}}>
      <QRCode
        size={256}
        style={elements.style}
        value={elements.content}
        viewBox={`0 0 256 256`}
      />
    </div>
  }

  if(elements.type === "qrCode") {
    return <div style={{backgroundColor:"white"}}>
      <QRCode
        size={256}
        style={elements.style}
        value={JSON.stringify({
          barcode:elements.barcode,
          itemPosition: elements.itemPosition,
          deviceId: deviceId,
          displayPosition: qrCodeIndex
        })}
        viewBox={`0 0 256 256`}
      />
    </div>
  }
}

const getBackground = (background) => {
  if(background && background.type === "video")  
    return <video style={{position:'absolute', width:"100%", height:"100%", aspectRatio:"16/9"}} autoPlay muted loop src={background.uri} type="video/webm">
    </video>
  else if(background && background.type === "img") {
    return  <img src={background.uri}  style={{position:'absolute', width:"100%", height:"100%", aspectRatio:"16/9"}} alt=''/>
  }
}

const DisplayComponent = ({display,deviceCode, deviceId,showDeviceId, displayPosition, qrCodeIndex}) => {
  console.log(showDeviceId)
  return (
    <div
      className='h-screen w-[100%] relative'
    >
      <div
        style={{
          height:'100%',
          width:"100%",
          display:'flex',
          flexDirection:'row',
          backgroundColor:'#000',
          justifyContent:"start",
          alignItems:"start",
          gap:10,
          padding:10,
        }}
      >
        {display.background && getBackground(display.background)}
        {display.elements && display.elements.map((element, index) => {
          if(Array.isArray(element)) {
            return <div 
              style={{
                borderWidth: 5,
                borderColor:"white",
                justifyContent:"center",
                alignItems:"center",
                display:'flex',
                flexDirection:"column",
                padding:10
              }} 
              key={index}
            >
                {element.map(asset => {
                  return deepMapElements(asset, deviceId, index, qrCodeIndex);
                })}
            </div>
          }
          else if (element.type === 'video') {
            const mime = element.content.includes('.webm') ? 'video/webm' : 'video/mp4';
            return (
              <video style={element.style} autoPlay muted loop playsInline>
                <source src={element.content} type={mime} />
              </video>
            );
          }
          else if(element.type === "img") {
            return <img 
                style={element.style}
                src={element.content}
              />
          }
          else if (element.type === "powerpoint") { 
            
            return <iframe
              src={`https://docs.google.com/gview?url=${element.content}&embedded=true&hl=Nl`}
              style={element.style}
            />
          }
          else if (element.type === "Iframe") {
            return <iframe
              src={element.content}
              style={element.style}
              sandbox="allow-scripts allow-forms allow-orientation-lock allow-pointer-lock allow-presentation" 

            />
          }
          else if (element.type === "url") {
          console.log("enter")
           return <iframe
              src={element.content}
              style={element.style}
              sandbox="allow-scripts allow-forms allow-orientation-lock allow-pointer-lock allow-presentation" 

            />
          }
          else if (element.type === "promotion") {
           return <iframe
              src={element.content}
              style={element.style}
            />
          }
          else if(element.type === "view") {
            return <div
              style={element.style} 
              key={index}
            >
                {element.content.map(asset => {
                  return deepMapElements(asset, deviceId, displayPosition, qrCodeIndex);
                })}
            </div>
          }
          else if(element.type === "displaySwitchButton") {
            return <button 
              style={element.style}
              key={index}
              // onClick={() => {
              //   setDisplay(element.displaySwitch);
              // }}
            >
              {element.content}
            </button>
          }
          else if(element.type === "viewTemplate") {
            return <iframe
              srcDoc={element.content}
              style={{...element.style, fontSize: 15, zoom: Math.min(parseInt(element.style.width), parseInt(element.style.height))/100 }}
            />
          }
          else if(element.type === "backgroundView") {
            return <div style={element.style}>
              {Array.isArray(element.content) && element.content.map(asset => {
                  return deepMapElements(asset, deviceId, displayPosition, qrCodeIndex);
              })}
            </div>
          }
        })}
        {showDeviceId && <div 
          style={{
            height:"10%",
            width:"10%",
            display:"flex",
            flexDirection:"column",
            alignItems:"center",
            justifyContent:"center",
            position:"absolute",
            top: "89%",
            left:"1%",
            borderColor:"white",
            borderWidth: 2,
            backgroundColor:"#000",
            borderRadius:10,
            padding:15}}
        >
          <h2 className='text-white text-2xl'>{deviceCode ? deviceCode : deviceId}</h2>
        </div>}
    </div>
  </div>
  )
}

export default DisplayComponent